/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Trash (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgTrash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M40 41v6m4-6v6M34 37h16m-1 0-.867 12.142A2 2 0 0 1 46.138 51h-8.276a2 2 0 0 1-1.995-1.858L35 37zm-4 0v-3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3z"
    />
  </svg>
);
export default SvgTrash;
